<template>
  <el-dialog
    class="modal-modify-imgcode"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
    append-to-body
    center
  >
    <div class="content">
      <div class="form-item">
        <div class="s-label">图形验证码：</div>
        <div class="input-box">
          <input
            v-model.trim="imgCode"
            type="text"
            @blur="$_validImgCode"
            @keyup.enter="$_submit"
            maxlength="4"
            autocomplete="off"
            placeholder="请输入图形验证码"
            class="inp"
            ref="imgCode"
          />
          <div class="img-code" @click.stop="$_getImgCodeUrl"><img :src="imgCodeSrc" /></div>

          <div v-if="validImgCode.tips" class="error-tips">
            {{validImgCode.tips}}
            <!-- 请输入正确的验证码 -->
            <div class="popper__arrow"></div>
          </div>
        </div>
        <div v-if="submit_tips" class="submit_tips">{{ submit_tips }}</div>
      </div>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">确定</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import Axios from "axios";

export default {
  name: "modal-imgcode",
  props: {
    title: { type: String, default: "" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      imgCode: '', // 角色ID
      imgCodeSrc: "",
      validImgCode: { tips: "", status: "" },
      submit_tips: ""
    };
  },
  methods: {
    $_getImgCodeUrl() {
      let timer = Date.parse(new Date());
      this.imgCodeSrc = `/ImageCodeAction?type=1&mode=1&_${timer}`;
    },
    // 校验图片验证码
    $_validImgCode() {
      this.validImgCode.tips = "";
      this.validImgCode.status = "";
      if (this.imgCode.match(/^[a-zA-Z0-9]{4}$/) === null) {
        this.validImgCode.tips = "请输入正确的验证码";
        this.validImgCode.status = "error";
        return false;
      }
      return true;
    },
    // 保存
    async $_submit() {
      if (this.imgCode === "") {
        this.$refs["imgCode"].focus();
      }
      if (
        !this.$_validImgCode()
      ){
        return false;
      }
      let url = `CodeAction?type=1&code=${this.imgCode}`;
      var actionData = {
        actionName: "candao.account.sendSmsCode",
        data: this.modalData
      };
      if(this.modalData.status === 0){
        var actionData = {
          actionName: "candao.account.sendSmsCode",
          data: this.modalData
        };
      }else if(this.modalData.status === 1){
        var actionData = {
          actionName: "candao.account.sendEmailCode",
          data: {aid: this.modalData.aid}
        };
      }
      // let result = await Axios.post(url, actionData);
      let result = await Axios({
        baseURL: '/',
        method: 'post',
        url, 
        data: actionData
      });
      if (result.data.status === 1) {
        this.visible = false;
        this.$emit("callback");
      }else{
        this.submit_tips = result.data.msg;
        this.$_getImgCodeUrl();
        setTimeout(() => {
          this.submit_tips = "";
        }, 5000);//5s后消失
      }
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created(){
    this.$_getImgCodeUrl();
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.modal-modify-imgcode{
  /deep/ .el-dialog{
    width: 450px;
    height: auto;
    box-shadow:0px 0px 4px 0px rgba(10,18,58,0.21);
    border-radius:10px;
    overflow: hidden;
    .el-dialog__header{
      padding: 0;
      background: #fff;
      border: none;
      border-radius: 0;
      text-align: center;
      .el-dialog__headerbtn .el-dialog__close{
        &:hover{
          color: #b0b0b0;
        }
      }
    }
    .el-dialog__title{
      font-size:20px;
      color: #151622;
      padding: 0;
      line-height: 70px;
    }
    .el-dialog__body{
      height: 242px;
      padding: 0 40px;
      background-color: #fff;
      border: none;
      .form-item{
        padding-top: 62px;
        .s-label{
          font-size: 14px;
          color: #283647;
          line-height: 100%;
        }
        .input-box{
          margin-top: 16px;
          height: 48px;
          position: relative;
          .inp{
            width:262px;
            height:48px;
            line-height: 48px;
            background:rgba(234,234,234,1);
            border-radius:3px;
            padding-left: 20px;
            font-size: 12px;
            color: #283647;
            border: none;
            outline: none;
          }
          .img-code{
            margin-left: 8px;
            width: 100px;
            height: 48px;
            line-height: 48px;
            display: inline-block;
            background-color: #eaeaea;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }
      .error-tips{
        top: 42px;
        background-color: rgba(8, 9, 24, 0.85);
        color: #fff;
        .popper__arrow:after{
          top: 0;
          border-bottom-color: rgba(8, 9, 24, 0.85);
        }
      }
      .submit_tips{
        padding: 12px 0 0 20px;
        line-height: 100%;
        font-size: 12px;
        color: #dd1e1e;
        background: url(~@/assets/images/icon_error_1.png) no-repeat left 10px;
      }
    }
    .el-dialog__footer{
      background-color: #fff;
      border: none;
      height: auto;
      padding: 10px 20px 20px;
      line-height: 100%;
      .el-button{
        width:100px;
        height:38px;
        border-radius:3px;
        border: none;
        background:rgba(215,215,215,1);
        font-size:14px;
        color: #333;
        margin: 0;
        &:hover{
          background: rgba(215,215,215,0.8);
        }
        &:active{
          background: rgba(215,215,215,0.8);
        }
        &.save__btn{
          background:rgba(46,50,84,1);
          color: #fff;
          &:hover{
            background: #373b5f;
          }
          &:active{
            background: #272b4a;
          }
        }
        &+.el-button{
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
